export default __webpack_public_path__ + "static/media/power.3c90b54d.svg";